var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"image-browser"},[_c('el-image',{attrs:{"src":_vm.thumbnailSrc,"preview-src-list":_vm.value ? [_vm.src] : []}},[_c('div',{staticClass:"image-slot",attrs:{"slot":"placeholder"},slot:"placeholder"},[_vm._v("\n      加载中"),_c('span',{staticClass:"dot"},[_vm._v("...")])])]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.label))])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-27e044ba","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PhotoBrowserMobile.vue
// module id = null
// module chunks = 